import { render, staticRenderFns } from "./ActivationEmailForm.vue?vue&type=template&id=59cf858c&"
import script from "./ActivationEmailForm.vue?vue&type=script&lang=js&"
export * from "./ActivationEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports